<template>
  <div>
    <ModalTemplate :showModal="showModalNote" width="1050px" @closeModal="closeModal">
      <template v-slot:headerModal>
        <div class="is-flex is-justify-content-space-between is-align-items-center">
          <div class="flex-center-vertical">
            <p class="averta-bold label-18 ml-3">Pilih Item Pekerjaan</p>
          </div>
          <div class="is-clickable" @click="closeModal">
            <b-icon icon="close"></b-icon>
          </div>
        </div>
      </template>
      <template v-slot:bodyModal>
        <div class="wrap-body-modal">
          <div class="px-5 pt-5 pb-3">
            <b-input
              placeholder="Cari Item Pekerjaan"
              @input="debouncedSearchItemWorking"
              v-model="searchItemWorking"
            ></b-input>
            <div class="content-list-item">
              <div v-if="isLoadingItem" class="is-relative wrap-loading-item">
                <b-loading :is-full-page="false" :active="true" :can-cancel="false">
                  <SpinnerIcon />
                </b-loading>
              </div>
              <div v-else-if="!isLoadingItem && listItemWorking.length > 0" class="body">
                <div
                  v-for="(item, index) in listItemWorking"
                  :key="`item-${index}`"
                  class="content-item-working p-3"
                  :class="[{ 'disabled': selectedDisabled && selectedItemWorkingId === item.id }]"
                >
                  <div class="is-flex" @click="selectedItemWorkingId = item.id">
                    <div class="mr-2 py-1 is-clickable">
                      <input
                        :id="`radio-${index}`"
                        :value="item.id"
                        type="radio"
                        v-model="selectedItemWorkingId"
                        class="is-clickable"
                      />
                    </div>
                    <label :for="`radio-${index}`" class="is-clickable c-w-100">
                      <div class="">
                        <p v-if="item.id > 0" class="color-grey mb-1">ID: {{ item.id }}</p>
                        <p
                          class="averta-bold title-item-working"
                          :class="{'mt-1': item.id < 1}"
                        >
                          {{ "detail_component" in item ? item.detail_component.detail_component_name : item.note }}
                        </p>
                      </div>
                    </label>
                  </div>
                  <ErrorComponent v-if="selectedDisabled && selectedItemWorkingId === item.id" title="Item pekerjaan sudah ditambahkan. Pilih item pekerjaan lain" />
                </div>
              </div>
              <div
                v-else-if="listItemWorking.length < 1"
                class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
              >
                <ProyekEmptyIcon />
                <p class="averta-bold">Tidak Ada Item Pekerjaan</p>
              </div>
            </div>
          </div>
          <div class="footer-modal">
            <ButtonApp
              height="45px"
              width="160px"
              :isDisabled="disabledButton"
              @click="handleSubmit"
            >
              <div class="flex-center">
                <p class="averta-bold">Simpan</p>
              </div>
            </ButtonApp>
          </div>
        </div>
      </template>
    </ModalTemplate>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce, alertErrorMessage } from '@/helpers'
import { ProyekEmptyIcon, SpinnerIcon } from '@/components/icons'
import ModalTemplate from '@/components/modal/ModalTemplate.vue'
import ButtonApp from '@/components/button/ButtonApp.vue'
import ErrorComponent from '../ErrorComponent.vue'

export default {
  name: 'ModalItemWorking',
  components: {
    ProyekEmptyIcon,
    SpinnerIcon,
    ModalTemplate,
    ButtonApp,
    ErrorComponent
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    editId: {
      type: [String, Number],
      default: null
    },
    disabledId: {
      type: Array,
      default: () => []
    },
    isBS: {
      type: Boolean,
      default: false
    },
    hideDLL: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      getDataPilihTukang: 'project/getDataPilihTukang'
    }),
    disabledButton () {
      return !this.selectedItemWorkingId || this.selectedDisabled
    },
    selectedDisabled () {
      return this.disabledId.some(item => item.note_item_id === this.selectedItemWorkingId)
    }
  },
  data () {
    return {
      searchItemWorking: '',
      listItemWorking: [],
      initListItemWorking: [],
      selectedItemWorkingId: null,
      isLoadingItem: false,
      showModalNote: false
    }
  },
  methods: {
    closeModal () {
      this.showModalNote = false
      this.$emit('closeModal')
    },
    filterListItemWorking () {
      this.listItemWorking = this.initListItemWorking.filter((item) => {
        let temp = ''
        if (item && item.note_item_working) {
          temp = item.note_item_working
        } else {
          temp = 'detail_component' in item ? item.detail_component.detail_component_name : item.note
        }
        return temp.toLowerCase().includes(this.searchItemWorking.toLowerCase())
      })
    },
    debouncedSearchItemWorking: debounce(function () {
      // this.filterListItemWorking()
      this.getListItemWorking(this.searchItemWorking)
    }, 300),
    getListItemWorking (keyword) {
      this.isLoadingItem = true

      const payload = {
        url: this.url,
        vendor_id: this.getDataPilihTukang.vendor.id
      }

      if (keyword) {
        payload.search = keyword
      }

      // if (this.isBS && !this.hideDLL) payload.with_dll = 1
      if (!this.hideDLL) payload.with_dll = 1

      this.$store
        .dispatch('unitPrice/getListItemWorkingUnitPrice', payload)
        .then(response => {
          const res = response.data.data

          this.initListItemWorking = JSON.parse(JSON.stringify(res))
          this.listItemWorking = res

          this.isLoadingItem = false
        })
        .catch(error => {
          this.isLoadingItem = false
          alertErrorMessage(error)
        })
    },
    handleSubmit () {
      if (this.editId === this.selectedItemWorkingId) {
        this.closeModal()
      } else {
        const getData = this.initListItemWorking.find((item) => item.id === this.selectedItemWorkingId)
        this.$emit('submit', getData)
      }
    }
  },
  watch: {
    showModal (val) {
      this.showModalNote = val
      if (val) {
        // OPEN MODAL
        this.getListItemWorking()
        this.selectedItemWorkingId = this.editId || null
      } else {
        // CLOSE MODAL
        this.selectedItemWorkingId = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.footer-modal {
  box-shadow: 0px -3px 30px 0px #00000012;
  padding: 20px 30px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  justify-content: flex-end;
}

.content-list-item {
  height: 21em;
  overflow: auto;
  border-top: 1px dashed $color-grey-2;
  margin-top: 1.5em;
  padding-top: 1.5em;
  padding-bottom: 1.5em;
}

.content-list-item .body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.content-list-item .content-item-working {
  border: 1px solid $color-grey-2;
  background: white;
  border-radius: 12px;
}

.content-list-item .content-item-working.disabled {
  border: 1px solid #E10009;
  background: #FFF5F6;
}

.content-item-working.disabled input[type=radio] {
  accent-color: #E10009;
}

.content-item-working input[type=radio] {
  width: 1.4em;
  height: 1.4em;
}

.content-item-working .title-item-working {
  max-height: 55px;
  display: inline-block;
  overflow: auto;
}

.wrap-loading-item {
  height: 20em;
  width: 100%;
}

.text-ellipsis-3 {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
